function make(hosts) {
  // Object.keys(hosts).map(key => (hosts[key] += `/${process.env.version}`));
  return hosts;
}

// const testdomain = 'api'
const dytestdomain = 'dyapi'
const moneydomain = '/money'


const pdomain = `/gmg`
const domain = `//test-gateway.jinyi999.cn`;
// const prodDomain = `//gateway.jinyi999.cn`;

// const general = {
//   mock: `http://${domain}`
// };

const dev = {
  // stockQuoteHost: `${domain}/rjhy-stock-quote/api/1`,
  rankHost: `${domain}/rjhy-stock-rank/api/1/biz`,
  gmgQuoteHost: `${domain}/rjhy-gmg-quote/api/1`,
  rjhyNewsHost: `${domain}/rjhy-news/api`,
  stockQuoteHost: `${domain}/rjhy-stock-quote/api/1`,
  stockDiagnosisHost: `${pdomain}/rjhy-stock-diagnosis/api/1`,
  quotes: `${dytestdomain}`,
  money: `${moneydomain}`,
  circle: `${domain}/rjhy-circle/api/1`,
  sms: `${domain}/rjhy-sms/api/1`,
  user: `${domain}/rjhy-user/api/1`,
  activity: `${domain}/rjhy-activity-manage/api/v1`,
};

const test = {
  rankHost: `${domain}/rjhy-stock-rank/api/1/biz`,
  gmgQuoteHost: `${domain}/rjhy-gmg-quote/api/1`,
  rjhyNewsHost: `${domain}/rjhy-news/api`,
  stockQuoteHost: `${domain}/rjhy-stock-quote/api/1`,
  stockDiagnosisHost: `${pdomain}/rjhy-stock-diagnosis/api/1`,
  quotes: `${dytestdomain}`,
  money: `${moneydomain}`,
  circle: `${domain}/rjhy-circle/api/1`,
  sms: `${domain}/rjhy-sms/api/1`,
  user: `${domain}/rjhy-user/api/1`,
  activity: `${domain}/rjhy-activity-manage/api/v1`,
};

const preview = {
};

const production = {
  // https://stockhq-aliyun.caixun99.com/curhq/QueryStockPriceVolume
  // stockQuoteHost: `${pdomain}/rjhy-stock-quote/api/1`,
  rankHost: `${pdomain}/rjhy-stock-rank/api/1/biz`,
  gmgQuoteHost: `${pdomain}/rjhy-gmg-quote/api/1`,
  rjhyNewsHost: `${pdomain}/rjhy-news/api`,
  stockQuoteHost: `${pdomain}/rjhy-stock-quote/api/1`,
  stockDiagnosisHost: `${pdomain}/rjhy-stock-diagnosis/api/1`,
  quotes: `${dytestdomain}`,
  money: `${moneydomain}`,
  circle: `${pdomain}/rjhy-circle/api/1`,
  sms: `${pdomain}/rjhy-sms/api/1`,
  user: `${pdomain}/rjhy-user/api/1`,
  activity: `${pdomain}/rjhy-activity-manage/api/v1`,
};


module.exports = env => {
  console.log('env', env)
  return make(
    {
      dev,
      test,
      preview,
      production
    }[env]
  )
}
